import React, { useEffect, useState } from 'react';
import '../SellerFinancialDashboard/SellerFinancialDashboard.css';
import axios from "axios";
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';

import { Link } from 'react-router-dom';
import { BaseUrl } from '../../App';
import SellerServicesUrl from '../../SellerServicesUrl';

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
);

export default function SellerFinancialDashboard() {

  const [financeData, setFinanceData] = useState(null);
  const [loading, setLoading] = useState(true);

  async function getFinancialData() {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        BaseUrl+SellerServicesUrl.SellerFinancialAccounts,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      

      setFinanceData(res.data.data);
      console.log("DATA:", res.data);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getFinancialData();
  }, []);

  const totalAmount = financeData?.total_account || 0;

  const months = [
    "يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
    "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
  ];

  const chartData = {
    labels: financeData?.monthly_orders?.map(
      (item) => months[item.month - 1]
    ) || [],

    datasets: [
      {
        label: '',
        data: financeData?.monthly_orders?.map(
          (item) => item.count
        ) || [],
        backgroundColor: '#ff7a00',
        borderRadius: 12,
        barThickness: 45,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'الطلبات الشهرية',
        font: {
          size: 20,
          weight: 'bold',
          
        },
        color: '#333',
        padding: {
          bottom: 25,
        },
      },
    },

    // scales: {
    //   x: {
    //     grid: {
    //       display: false,
    //     },
    //     ticks: {
    //       font: {
    //         size: 16,
    //       },
    //       color: '#444',
    //     },
    //   },

    //   y: {
    //     beginAtZero: true,
    //     max:3,
    //     grid: {
    //       color: '#eaeaea',
    //        borderDash: [8, 8], 
    //     },
    //     ticks: {
    //       stepSize: 0.5,
    //       font: {
    //         size: 16,
    //       },
    //       color: '#444',
    //     },
    //   },
    // },
    scales: {
  x: {
    grid: {
      display: true,
      color: '#D6DDE5',
      borderDash: [6, 6],
      drawBorder: false,
      drawTicks: false,
    },

    ticks: {
      font: {
        size: 16,
      },
      color: '#444',
    },
  },

  y: {
    beginAtZero: true,
    max: 3,

    grid: {
      color: '#D6DDE5',
      borderDash: [6, 6],
      drawBorder: false,
      drawTicks: false,
    },

    ticks: {
      stepSize: 0.5,

      callback: function(value) {
        return Number(value);
      },

      font: {
        size: 16,
      },

      color: '#444',
    },
  },
},
  };

  return (
    <div className="fin-page mt-5 fw-bold bg-light">
      <div className="fin-container">

        <div className="fin-breadcrumb mt-5">
          <span className="fin-breadcrumb-main fw-bold">الرئيسية</span>
          <span className="fin-breadcrumb-sep">/</span>
          <span className="fin-breadcrumb-current">الحسابات المالية</span>
        </div>

        <h2 className="fin-page-title">الحسابات المالية</h2>

        {/* <div className="fin-summary-card"> */}
                      {/* <Link
  to="/seller/sellerfinancialreports"
  className="fin-summary-label text-white fw-bold d-flex align-items-center gap-3 text-decoration-none"
></Link> */}

          {/* <div className="fin-summary-text"> */}
            {/* <span className="fin-summary-label text-white fw-bold d-flex align-items-center gap-3">
                          <span className='fin-summary-icon ' >$</span>
تفاصيل الأرباح
            </span> */}
            {/* <Link
  to="/seller/sellerfinancialreports"
  className="fin-summary-label text-white fw-bold d-flex align-items-center gap-3 text-decoration-none"
>
  <span className='fin-summary-icon'>$</span>
  تفاصيل الأرباح
</Link> */}

            {/* <span className="fin-summary-amount text-white fw-bold">
              {loading ? "Loading..." : `${Number(totalAmount).toFixed(2)} ر.س`}
            </span> */}
          {/* </div> */}
          <div className="fin-summary-card">

  <Link
    to="/seller/sellerfinancialreports"
    className="fin-summary-label text-white fw-bold d-flex align-items-center justify-content-between gap-3 text-decoration-none w-100"
  >

    <div className="fin-summary-text ">
      <span className="fin-summary-label text-white fw-bold d-flex align-items-center gap-3">
      <span className="fin-summary-icon">$</span>
      تفاصيل الأرباح
</span>
    </div>

    <span className="fin-summary-amount text-white fw-bold">
      {loading
        ? "Loading..."
        : `${Number(totalAmount).toFixed(2)} ر.س`}
    </span>

  </Link>

</div>

          {/* <div className="fin-summary-icon">
            <span>$</span>
          </div> */}
              {/* <span className="fin-summary-amount text-white fw-bold">
              {loading ? "Loading..." : `${Number(totalAmount).toFixed(2)} ر.س`}
            </span> */}
        </div>

        <div className="fin-chart-card mb-5">
          <Bar data={chartData} options={options} />
        </div>

      </div>
  );

}  